module.exports = __webpack_public_path__ + "img/VE.d42cc2f3.svg";